// extracted by css-extract-rspack-plugin
export default {"root":"root-Y76kQl"};